'use client';

import Breadcrumbs from '@/components/Breadcrumb';
import HeaderNavigator from '@/components/Navigator';
import React from 'react';
import OutputMaterialListWrapper from './output-material-wrapper';
import routes from '@/app/routes';
import { OutputMaterialProvider } from '../context';

const MatchMakerOutputMaterialListPage: React.FC = () => {
  return (
    <>
      <HeaderNavigator title="Select produced material" />
      <Breadcrumbs
        items={[
          { label: 'Matchmaker', path: routes.MATCH_MAKER },
          { label: 'Select produced material' },
        ]}
        maxVisible={4}
        className="w-full fixed top-[112px]"
      />
      <OutputMaterialProvider>
        <div className="px-6 py-6 md:px-14">
          <OutputMaterialListWrapper />
        </div>
      </OutputMaterialProvider>
    </>
  );
};

export default MatchMakerOutputMaterialListPage;
